/**
 * Espelho neutro do contador de SSE zumbi.
 *
 * <p><b>Zumbi</b> é a reconexão que o watchdog teve que forçar porque o canal
 * tinha morrido <i>sem o EventSource perceber</i> — a falha que não aparece em
 * lugar nenhum, porque do ponto de vista do player a conexão "estava aberta".
 * Só contam as causas de watchdog: `network-online` e `visibility-visible` são
 * reconexões esperadas e inflariam a taxa.</p>
 *
 * <p><b>Por que um módulo separado, e não ler do RemoteOpsService:</b> o
 * snapshot de saúde é montado pelo `SyncService`, e importar o RemoteOps de lá
 * fecharia um ciclo (`SyncService` → `RemoteOpsService` → `syncStore` →
 * `SyncService`) — que em ESM não estoura, só entrega `undefined` em runtime,
 * na frota, sem erro de build. Este módulo não importa nada, então qualquer um
 * pode ler dele.</p>
 *
 * <p>O contador de verdade continua sendo o `reconnectCounts` do RemoteOps, por
 * causa; aqui é só o total que vai pra série. Um número, em memória, zerado a
 * cada boot — igual ao uptime que acompanha a amostra.</p>
 */

let zumbis = 0;

/** Chamado pelo RemoteOps quando o watchdog detecta canal morto. */
export function registrarSseZumbi(): void {
  zumbis += 1;
}

export function lerSseZumbis(): number {
  return zumbis;
}

/** Só pra teste: devolve o contador ao estado de boot. */
export function resetarSseZumbis(): void {
  zumbis = 0;
}
